import {forkJoin, interval, Observable, of, switchMap} from "rxjs";
import {PlayerBase} from "./player.base";
import {delay, take, tap} from "rxjs/operators";


export class PlayerAnim {
  player;
  scaleX = 1;
  scaleY = 1;
  anim;

  animIn;
  animOut;
  animPlay;
  animTouch;

  mousedown;
  mouseup;
  mouseleave;


  constructor(player, animInfo) {
    this.player = player;

    let parentLayout;
    if (this.player.parentPlayer != null && (this.player.parentPlayer instanceof PlayerBase) && this.player.playerObject.$.autoScaling == "1") {
      parentLayout = this.player.parentPlayer.data.Layout[0].$;
    }
    if (parentLayout != null) {
      this.scaleX = this.player.parentPlayer.scaleX;
      this.scaleY = this.player.parentPlayer.scaleY;
    }


    const infoIn = (animInfo?.In!=null) ? animInfo.In[0].$ : {};
    const infoOut = (animInfo?.Out!=null) ? animInfo.Out[0].$ : {};
    const infoPlay = (animInfo?.Play!=null) ? animInfo.Play[0].$ : {};
    const infoTouch = (animInfo?.Touch!=null) ? animInfo?.Touch[0].$ : {};


    // In
    if (infoIn.enabled=='1') {
      this.animIn = {}
      //delay
      this.animIn.delay = Number(infoIn.delay);
      // duration
      this.animIn.duration = Number(infoIn.duration);
      // fade
      if (this.player.component!=null) {
        const opacity = this.player.component.nativeElement.style.opacity;
        if (opacity == '' || opacity == '1') {
          this.animIn.fade = this.getBool(infoIn.fadeFrq);
        }
      }
      // move
      this.animIn.move = this.getBool(infoIn.moveFrq);
      if (this.animIn.move) {
        const a = (infoIn.moveDir=='fixed') ? infoIn.moveAngle * 0.01745329252 : Math.random() * Math.PI * 2;
        const w = ((this.player.parentPlayer!=null) ? this.player.parentPlayer.actualWidth : this.player.actualWidth) * infoIn.moveIntense;
        const h = ((this.player.parentPlayer!=null) ? this.player.parentPlayer.actualHeight : this.player.actualHeight)  * infoIn.moveIntense;
        this.animIn.hoz = w * Math.cos(a);
        this.animIn.ver = h * Math.sin(a);
      }
      // scale
      this.animIn.scale = this.getBool(infoIn.scaleFrq);
      // rotate
      this.animIn.rotate = this.getBool(infoIn.rotateFrq);
      if (this.animIn.rotate) {
        if (infoIn.rotateType=='fixed') {
          this.animIn.rotateAngle = Number(infoIn.rotations) * 360;
        } else {
          this.animIn.rotateAngle = (Math.random() * 20 - 10) * 360;
        }
      }
      // blur
      if (this.player.component!=null) {
        if (this.player.component.nativeElement.style.filter == '') {
          if (this.getBool(infoIn.blurFrq)) {
            this.animIn.blurValue = Number(infoIn.blurValue);
          }
        }
      }
      // textTyping
      this.animIn.textTyping = this.getBool(infoIn.textTypingFrq);
    }

    // Out
    if (infoOut.enabled=='1') {
      this.animOut = {}
      // delay
      this.animOut.delay = Number(infoOut.delay);
      // duration
      this.animOut.duration = Number(infoOut.duration);
      // fade
      if (this.player.component != null) {
        const opacity = this.player.component.nativeElement.style.opacity;
        if (opacity == '' || opacity == '1') {
          this.animOut.fade = this.getBool(infoOut.fadeFrq);
        }
      }
      // move
      this.animOut.move = this.getBool(infoOut.moveFrq);
      if (this.animOut.move) {
        let a;
        if (infoOut.moveDir=='revert') {
          if (this.animOut.hoz!=null) {
            this.animOut.hoz = -this.animIn.hoz;
            this.animOut.ver = -this.animIn.ver;
          }
        } else {
          if (infoOut.moveDir == 'fixed') {
            a = infoOut.moveAngle * 0.01745329252;
          } else if (infoOut.moveDir == 'random') {
            a = Math.random() * Math.PI * 2;
          }
          const w = ((this.player.parentPlayer!=null) ? this.player.parentPlayer.actualWidth : this.player.actualWidth) * infoOut.moveIntense;
          const h = ((this.player.parentPlayer!=null) ? this.player.parentPlayer.actualHeight : this.player.actualHeight)  * infoOut.moveIntense;
          this.animOut.hoz = w * Math.cos(a);
          this.animOut.ver = h * Math.sin(a);
        }
      }
      // scale
      this.animOut.scale = this.getBool(infoOut.scaleFrq);
      // rotate
      this.animOut.rotate = this.getBool(infoOut.rotateFrq);
      if (this.animOut.rotate) {
        if (infoOut.rotateType == 'fixed') {
          this.animOut.rotateAngle = Number(infoOut.rotations) * 360;
        } else if (infoOut.rotateType == 'rand') {
          this.animOut.rotateAngle = (Math.random() * 20 - 10) * 360;
        } else if (infoOut.rotateType == 'revert') {
          if (this.animIn.rotateAngle!=null) {
            this.animOut.rotateAngle = -this.animIn.rotateAngle;
          }
        }
      }

      // blur
      if (this.player.component!=null) {
        if (this.player.component.nativeElement.style.filter == '') {
          if (this.getBool(infoOut.blurFrq)) {
            this.animOut.blurValue = Number(infoOut.blurValue);
          }
        }
      }
      // textTyping
      this.animOut.textTyping = this.getBool(infoOut.textTypingFrq);
    }

    // Play
    if (infoPlay?.enabled=='1') {
      this.animPlay = {}
      // duration
      const duration = Number(infoPlay.duration);
      // frequency
      const frequency = Number(infoPlay.frequency);
      this.animPlay.duration = 1000 / frequency;
      this.animPlay.iterations = duration * frequency / 1000;

      // rotate
      if (this.getBool(infoPlay.rotateFrq)) {
        this.animPlay.rotate = Number(infoPlay.rotateValue);
      }
      //scale
      if (this.getBool(infoPlay.scaleFrq)) {
        this.animPlay.scale = Number(infoPlay.scaleValue);
      }
      // fade
      if (this.player.component!=null) {
        const opacity = this.player.component.nativeElement.style.opacity;
        if (opacity == '' || opacity == '1') {
          this.animPlay.fade = this.getBool(infoPlay.fadeFrq);
        }
      }
    }

    // Touch
    if (infoTouch.enabled=='1') {
      this.animTouch = {}
      // duration
      this.animTouch.duration = Number(infoTouch.duration);
      // scale
      this.animTouch.scale = Number(infoTouch.scaleValue);
    }
  }


  getBool(str) {
    return (Math.random() < Number(str));
  }


  in(): Observable<any> {
    this.cancelAnim();

    if (this.animIn == null) {
      this.player.display(true);
      return of(null);
    }

    const list = [];

    if (this.player.component == null) {
      const speed = this.animIn.duration / 10;
      if (this.player.filter!=null) {
        this.player.filter.alpha = 0;
      }
      list.push(interval(speed).pipe(
        take(10),
        tap(i => {
          this.player.filter.alpha = (i / 10);
        })
      ));
    } else {
      if (this.player.genericElm?.label!=null && this.animIn.textTyping) {
        const str = this.player.genericElm.label;
        if (str.length > 0) {
          let i = 0;
          const speed = this.animIn.duration / str.length;
          list.push(interval(speed).pipe(
            take(str.length),
            tap(() => {
              i++;
              this.player.genericElm.labelAnchor.innerText = str.substring(0, i);
            })
          ))
        }
      }
      list.push(new Observable<any>(sub => {
        const frame1: any = {};
        const frame2: any = {};
        frame1.transform = '';
        frame2.transform = '';
        if (this.animIn.hoz != null) {
          frame1.transform += ' translateX(' + (-this.animIn.hoz * this.scaleX) + 'px)';
          frame2.transform += ' translateX(0px)';
        }
        if (this.animIn.ver != null) {
          frame1.transform += ' translateY(' + (-this.animIn.ver * this.scaleY) + 'px)';
          frame2.transform += ' translateY(0px)';
        }
        if (this.animIn.rotateAngle != null) {
          frame1.transform += ' rotate(' + this.animIn.rotateAngle + 'deg)'
          frame2.transform += ' rotate(0)'
        }
        if (this.animIn.fade) {
          frame1.opacity = 0;
          frame2.opacity = 1;
        }
        if (this.animIn.scale) {
          frame1.scale = 0;
          frame2.scale = 1;
        }
        if (this.animIn.blurValue != null) {
          frame1.filter = ' blur(' + this.animIn.blurValue + 'px)';
          frame2.filter = ' blur(0px)';
        }

        const options = {
          iterations: 1,
          duration: this.animIn.duration,
          easing: "ease-in-out"
        }

        this.anim = this.player.component.nativeElement.animate([frame1, frame2], options);
        this.anim.onfinish = (event) => {
          this.anim = null;
          sub.next("completed");
          sub.complete();
        };
      }))
    }
    return of('anim').pipe(
      delay(this.animIn.delay),
      switchMap( a => {
        this.player.display(true);
        return forkJoin(list);
      })
    )
  }

  out(): Observable<any> {
    this.cancelAnim();
    if (this.animOut == null) {
      return of(null);
    }

    const list = [];

    if (this.player.component == null) {
      const speed = this.animOut.duration / 10;
      list.push(interval(speed).pipe(
        take(10),
        tap(i => {
            if (this.player.filter!=null) {
                this.player.filter.alpha = ((9 - i) / 10);
            }
        })
      ));
    } else {
      if (this.player.genericElm?.label!=null && this.animOut.textTyping) {
        const str = this.player.genericElm.label;
        if (str.length == 0) {
          return of('label');
        }
        let i = str.length - 1;
        const speed = this.animOut.duration / str.length;
        list.push(interval(speed).pipe(
          take(str.length),
          tap(() => {
            this.player.genericElm.labelAnchor.innerText = str.substring(0, i);
            i--;
          })
        ));
      }
      list.push(new Observable<any>(sub => {
        const frame1: any = {};
        const frame2: any = {};
        frame1.transform = '';
        frame2.transform = '';

        if (this.animOut.hoz != null) {
          frame1.transform += ' translateX(0px)';
          frame2.transform += ' translateX(' + this.animOut.hoz * this.scaleY + 'px)';
        }
        if (this.animOut.ver != null) {
          frame1.transform += ' translateY(0px)';
          frame2.transform += ' translateY(' + this.animOut.ver * this.scaleY + 'px)';
        }
        if (this.animOut.rotateAngle != null) {
          frame1.transform += ' rotate(0)'
          frame2.transform += ' rotate(' + (-this.animOut.rotateAngle) + 'deg)'
        }
        if (this.animOut.fade) {
          frame1.opacity = 1;
          frame2.opacity = 0;
        }
        if (this.animOut.scale) {
          frame1.scale = 1;
          frame2.scale = 0;
        }
        if (this.animOut.blurValue != null) {
          frame1.filter = ' blur(0px)';
          frame2.filter = ' blur(' + this.animOut.blurValue + 'px)';
        }


        const options = {
          iterations: 1,
          duration: this.animOut.duration,
          easing: "ease-in-out"
        }

        this.anim = this.player.component.nativeElement.animate([frame1, frame2], options);
        this.anim.onfinish = (event) => {
          this.anim = null;
          this.player.component.nativeElement.style.left = "8192px"
          sub.next("completed");
          sub.complete();
        };
      }))
    }

    return of('anim').pipe(
      delay(this.animOut.delay),
      switchMap( a => {
        //??? this.player.display(true);
        return forkJoin(list);
      })
    )
  }


  play(): Observable<any> {
    this.cancelAnim();
    if (this.animPlay != null && this.player.component != null) {
      const frame1: any = {};
      const frame2: any = {};
      const frame3: any = {};
      const frame4: any = {};
      const frame5: any = {};
      if (this.animPlay.rotate) {
        frame1.transform = 'rotate(0deg)'
        frame2.transform = 'rotate('+ this.animPlay.rotate +'deg)'
        frame3.transform = 'rotate(0deg)'
        frame4.transform = 'rotate(-'+this.animPlay.rotate+'deg)'
        frame5.transform = 'rotate(0deg)'
      }
      if (this.animPlay.fade) {
        frame1.opacity = 1;
        frame2.opacity = 0;
        frame3.opacity = 1;
        frame4.opacity = 0;
        frame5.opacity = 1;
      }
      if (this.animPlay.scale) {
        frame1.scale = 1;
        frame2.scale = this.animPlay.scale;
        frame3.scale = 1;
        frame4.scale = this.animPlay.scale;
        frame5.scale = 1;
      }
      const options = {
        duration: this.animPlay.duration,
        iterations: this.animPlay.iterations,
      }
      this.anim = this.player.component.nativeElement.animate([frame1, frame2, frame3, frame4, frame5], options);
    }
    return of('anim');
  }


  touchIn() {
    this.cancelAnim();
    if (this.animTouch != null) {
      const frame1: any = {};
      const frame2: any = {};
      frame1.scale = 1;
      frame2.scale = this.animTouch.scale;
      const options = {
        iterations: 1,
        duration: this.animTouch.duration,
        easing: "ease-in-out"
      }
      this.anim = this.player.component.nativeElement.animate([frame1, frame2], options);
      this.anim.onfinish = (event) => {
        this.anim = null;
        this.player.component.nativeElement.style.scale = this.animTouch.scale;
      };
    }
  }

  touchOut() {
    this.cancelAnim();
    if (this.animTouch != null) {
      this.player.component.nativeElement.style.scale = 1;
      const frame1: any = {};
      const frame2: any = {};
      frame1.scale = this.animTouch.scale;
      frame2.scale = 1;
      const options = {
        iterations: 1,
        duration: this.animTouch.duration,
        easing: "ease-in-out"
      }
      this.anim = this.player.component.nativeElement.animate([frame1, frame2], options);
      this.anim.onfinish = (event) => {
        this.anim = null;
      };
    }
  }

  touchCancel() {
    this.cancelAnim();
    this.player.component.nativeElement.style.scale = 1;
  }

  cancelAnim() {
    if (this.anim!=null) {
      this.anim.cancel();
      this.anim = null;
    }
  }


  addTouchListeners() {
    /*
      //  this line cause memory leak !!!!
      this.component.nativeElement.ondragstart = () => {
        return false;
      };
    */

    this.mousedown = () => {
      this.touchBegin();
    }
    this.player.component.nativeElement.addEventListener('mousedown', this.mousedown);
  }

  touchBegin() {
    this.touchIn();

    this.mouseup = () => {
      this.touchOut();
      this.touchEnd();
    }
    this.player.component.nativeElement.addEventListener('mouseup', this.mouseup);

    this.mouseleave = () => {
      this.touchCancel();
      this.touchEnd();
    }
    this.player.component.nativeElement.addEventListener('mouseleave', this.mouseleave);

  }

  touchEnd() {
    if (this.mouseup!=null) {
      this.player.component.nativeElement.removeEventListener('mouseup', this.mouseup);
      this.mouseup = null;
    }
    if (this.mouseleave!=null) {
      this.player.component.nativeElement.removeEventListener('mouseleave', this.mouseleave);
      this.mouseleave = null;
    }
  }

  removeTouchListeners() {
    this.cancelAnim();

    if (this.mousedown!=null) {
      this.player.component.nativeElement.removeEventListener('mousedown', this.mousedown);
      this.mousedown = null;
    }

    if (this.mouseup!=null) {
      this.player.component.nativeElement.removeEventListener('mouseup', this.mouseup);
      this.mouseup = null;
    }

    if (this.mouseleave!=null) {
      this.player.component.nativeElement.removeEventListener('mouseleave', this.mouseleave);
      this.mouseleave = null;
    }

  }

}
